var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('cephalicBlock',{attrs:{"NewList":_vm.responseData}}),_c('div',[_vm._v("21111")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }